import axios from "axios"
import React, { useState, useEffect, useMemo, Fragment, useRef } from "react"

import { FormControl, InputLabel, Input, FormHelperText, Alert } from "@mui/material"
import WebService from "../util/webService"
import { encodeParams, getAction, isAllDigits } from "../util/helper"
// redux
import { useSelector, useDispatch } from "react-redux"
// MUI Table
import CssBaseline from "@mui/material/CssBaseline"
import MUITable from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"
// react-table
import { useTable, useExpanded } from "react-table"
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import SearchIcon from "@mui/icons-material/Search"
import AddCircleIcon from "@mui/icons-material/AddCircle"
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from "@mui/material"
import { styled, alpha } from "@mui/material/styles"
import "@scss/App.scss"
import Button from "@mui/material/Button"
import FlatButton from "../components/FlatButton"
import useSnackbar from "../hooks/useSnackbar"
import MyTableHead from "../components/MyTableHead"
import useIndicator from "../hooks/useIndicator"
import Indicator from "../components/Indicator"
import MyDialog from "../components/MyDialog"
import useForm from "../hooks/useForm"
import useDelegate from "@hooks/useDelegate"

import Box from "@mui/material/Box"

// pagination
import { useTheme } from "@mui/material/styles"
import FirstPageIcon from "@mui/icons-material/FirstPage"
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft"
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight"
import LastPageIcon from "@mui/icons-material/LastPage"
import ControlPointIcon from "@mui/icons-material/ControlPoint"
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline"

import moment from "moment"
import { Avatar, Grid, Container } from "@mui/material/"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { Link, useNavigate } from 'react-router-dom';
import { setSchola } from '@redux/actions/scholaAction';
import useAlert from "@hooks/useAlert";
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
const Boxs = styled(Box)`
	padding-bottom: 40px !important;
`

const FormHelperTexts = styled(FormHelperText)`
	width: 100%;
	padding-left: 16px;
	font-weight: 700 !important;
	color: #d32f2f !important;
  font-size: 0.85rem !important;
`

const SchoolPage = () => {
  const dateFormat = "YYYY-MM-DD HH:mm:ss"

  const fields = [
    { field: "id", placeholder: "ID", type: "text", value: -1, visible: true, disabled: false, canSrch: true, selList: [] },
    { field: "name", placeholder: "학교명", type: "text", value: "", visible: true, disabled: false, canSrch: true, selList: [] },
    { field: "level", placeholder: "레벨", type: "text", value: "02", visible: false, disabled: false, canSrch: true, selList: [] },
    { field: "phone", placeholder: "대표전화", type: "number", value: "", visible: true, disabled: false, canSrch: false, selList: [] },
    { field: "fax", placeholder: "팩스", type: "number", value: "", visible: true, disabled: false, canSrch: false, selList: [] },
    { field: "estbGubun", placeholder: "구분", type: "text", value: "국립", visible: false, disabled: false, canSrch: false, selList: [] },
    { field: "openDate", placeholder: "개교기념일", type: "text", value: "20000101", visible: false, disabled: false, canSrch: false, selList: [] },
    { field: "estbDate", placeholder: "설립일", type: "text", value: "20000101", visible: false, disabled: false, canSrch: false, selList: [] },
    { field: "oldZipCode", placeholder: "설립일", type: "text", value: "000000", visible: false, disabled: false, canSrch: false, selList: [] },
    { field: "oldAddr1", placeholder: "설립일", type: "text", value: "", visible: false, disabled: false, canSrch: false, selList: [] },
    { field: "oldAddr2", placeholder: "설립일", type: "text", value: "", visible: false, disabled: false, canSrch: false, selList: [] },
    { field: "newZipCode", placeholder: "우편번호", type: "number", value: "", visible: true, disabled: false, canSrch: false, selList: [] },
    { field: "newAddr1", placeholder: "주소", type: "text", value: "", visible: true, disabled: false, canSrch: false, selList: [] },
    { field: "newAddr2", placeholder: "주소상세", type: "text", value: "", visible: true, disabled: false, canSrch: false, selList: [] },
    { field: "homepage", placeholder: "홈페이지", type: "text", value: "", visible: false, disabled: false, canSrch: false, selList: [] },
    { field: "manager", placeholder: "매니저", type: "text", value: "", visible: false, disabled: false, canSrch: false, selList: [] },
    { field: "msgPhone", placeholder: "발신번호(네이버 등록 필수)", type: "text", value: "", visible: true, disabled: false, canSrch: false, selList: [] },
    { field: "email", placeholder: "비고", type: "text", value: "", visible: false, disabled: false, canSrch: false, selList: [] },
    { field: "remark", placeholder: "비고", type: "text", value: "", visible: false, disabled: false, canSrch: false, selList: [] },
    { field: "companyId", placeholder: "companyId", type: "text", value: -1, visible: false, disabled: false, canSrch: false, selList: [] },
    { field: "uptTime", placeholder: "수정일시", type: "text", value: "", visible: false, disabled: false, canSrch: false, selList: [] },
  ]

  const visibleColumns = fields.filter((col) => col.visible)
  const defRecord = {}
  fields.forEach((d) => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []
  const defTerms = {}
  fields
    .filter((col) => col.canSrch)
    .map((d) => d.field)
    .forEach((d) => (defTerms[d] = ""))
  // const [record, set_record] = useState(defRecord)
  const [dataList, set_dataList] = useState(null)
  const [fieldList, set_fieldList] = useState([])
  const [schoolList, set_schoolList] = useState([])
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: 10 })
  const termsRef = useRef({})
  const buttonRef = useRef(null)
  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { alert, renderAlert } = useAlert()
  const [companies, set_companies] = useState([])
  const recordRef = useRef(defRecord)

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      buttonRef.current.click()
    }
  }

  const fetchCompanies = async () => {
    const url = `/company`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
    }
    const repMessage = JSON.parse(resp.repMessage)
    let records = JSON.parse(repMessage.records)
    records = records.filter(r => r.statCode === 'S002')
    records.sort((a, b) => a.name.localeCompare(b.name))
    records.unshift({ id: -1, name: '없음' })
    set_companies(records)
  }

  useEffect(() => {
    fetchCompanies()
  }, [])

  useEffect(() => {
    onLoad()
  }, [pageInfo])

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress)
    return () => {
      document.removeEventListener("keydown", handleKeyPress)
    }
  }, [])

  const onLoad = async () => {
    let url = '/school'

    openIndicator()
    let resp = await WebService.get(url, { pageNum: pageInfo.pageNum, pageSize: pageInfo.pageSize, terms: JSON.stringify(termsRef.current) })
    closeIndicator()

    if (resp.repCode === "ack") {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      const totalCount = repMessage.totalCount
      set_totalCount(totalCount)
      records.forEach((r) => {
        r.isDetail = false
        r.schoolRltnList = []
      })

      set_dataList(records)
    }
    else {
      alert(resp.repMessage)
    }

    const newFields = [...fields]
    set_fieldList(newFields)
  }

  const onDetail = async (id) => {

    // const url = '/common/company/school/rltn'
    // openIndicator()
    // const resp = await WebService.get(url)
    // closeIndicator()
    // if(resp.repCode === 'ack') {
    //   const repMessage = JSON.parse(resp.repMessage)
    //   const records = JSON.parse(repMessage.records)
    //   const newRecord = {...recordRef.current}
    //
    //   const rltn = records.find(r => +r.schoolId === +record.id)
    //   if(rltn) {
    //     const company = companies.find(r => +r.id === +rltn.companyId) 
    //     if(company) {
    //       newRecord.companyId = company.id
    //     }
    //     else {
    //       newRecord.companyId = -1
    //     }
    //   }
    //   else {
    //       newRecord.companyId = -1
    //   }
    //   set_record(newRecord)
    //   recordRef.current = newRecord
    // }

    dgHandler[1](true)
  }

  const onDelete = async (id) => {
    const url = `/school`
    const resp = await WebService.delete(url, { id: id })
    if (resp.repCode === "ack") {
      onLoad()
      openSnackbar("삭제되었습니다.")
    } else {
      openSnackbar(resp.repMessage)
    }
  }

  const onCreate = () => {
    const now = moment().format(dateFormat)
    const newRecord = {
      ...defRecord, uptTime: now,
      schoolRltnList: []
    }
    // set_record(newRecord)
    recordRef.current = newRecord
    dgHandler[1](true)
  }

  const onSearch = () => {
    onLoad()
  }

  const onClear = () => {
    termsRef.current = {}
  }

  const handleChangePage = (event, newPage) => {
    set_pageInfo({ ...pageInfo, pageNum: newPage })
  }

  const handleChangeRowsPerPage = (event) => {
    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({ pageNum: 0, pageSize: pageSize })
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
    }

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
    }

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
    }

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label='first page'>
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label='previous page'>
          {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='next page'>
          {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='last page'>
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }

  const DgContent = () => {

    const fetchCompanyRltn = async (id) => {
      const url = '/common/company/school/rltn'
      openIndicator()
      const resp = await WebService.get(url)
      closeIndicator()

      if (resp.repCode === 'ack') {
        const repMessage = JSON.parse(resp.repMessage)
        const records = JSON.parse(repMessage.records)

        const rltn = records.find(r => +r.schoolId === +recordRef.current.id)
        if (rltn) {
          const company = companies.find(r => +r.id === +rltn.companyId)
          if (company) {
            factor.companyId = company.id
          }
          else {
            factor.companyId = -1
          }
        }
        else {
          factor.companyId = -1
        }
        updateState()
      }
    }

    const onSubmit = async () => {
      const errors = await handleChange()
      if (Object.keys(errors).length > 0) {
        alert('화면의 에러를 확인하세요.')
        return
      }

      const url = `/school/company/id/${factor.companyId}`
      const now = moment().format(dateFormat)
      handleChange({target:{name:'uptTime', value:now}})
      const data = factor
      console.log('data=>', data)
      const resp = await WebService.post(url, data)

      if (resp.repCode !== "ack") {
        alert(resp.repMessage)
        return
      }

      const repMessage = JSON.parse(resp.repMessage)
      const record = JSON.parse(repMessage.record)
      // console.log('record=>', record)
      // updateState(record)
      handleChange({target:{name:'id', value: record.id}})
      updateState()
      onLoad()
      alert("저장되었습니다.")
    }

    const validate = (name, value) => {
      let err = ''
      if (name === 'name') {
        // console.log('smstId ===>', value)
        if (!value || name.trim().length == 0) {
          err = '학교명이 비어 있습니다.'
        }
      }
      if (name === 'phone') {
        if (!value || value.trim().length == 0) {
          err = '대표전화가 비어 있습니다.'
        }
        else {
          if (!isAllDigits(value)) {
            err = '대표전화는 숫자만 가능합니다.'
          }
        }
      }
      if (name === 'fax') {
        if (!value || value.trim().length == 0) {
          err = '팩스가 비어 있습니다.'
        }
        else {
          if (!isAllDigits(value)) {
            err = '팩스는 숫자만 가능합니다.'
          }
        }
      }
      if (name === 'newZipCode') {
        if (!value || value.trim().length == 0) {
          err = '우편번호 비어 있습니다.'
        }
        else {
          if (!isAllDigits(value)) {
            err = '우편번호는 숫자만 가능합니다.'
          }
          if (value.length !== 5) {
            err = '우편번호는 5 자리입니다.'
          }
        }
      }
      if (name === 'newAddr1') {
        if (!value || value.trim().length == 0) {
          err = '주소가 비어 있습니다.'
        }
      }
      if (name === 'newAddr2') {
        if (!value || value.trim().length == 0) {
          err = '주소상세가 비어 있습니다.'
        }
      }
      if (name === 'msgPhone') {
        if (value && value.trim().length > 0) {
          if (!isAllDigits(value)) {
            err = '발신번호는 숫자만 가능합니다.'
          }
        }
      }
      return err
    }

    const { activeRow, errors, updateState, handleChange, handleSubmit, factor } = useDelegate({
      initialValues: { ...recordRef.current },
      onSubmit: onSubmit,
      validate: validate,
    })

    const onChangeCompany = async (e) => {
      factor.companyId = e.target.value
      updateState()
    }

    useEffect(() => {
      fetchCompanyRltn()
    }, [])

    return (
      <Container component='main' maxWidth='lg'>
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}>
          <Typography component='h1' variant='h5'>
            기본정보
          </Typography>
          <Boxs component='form' noValidate sx={{ mt: 3 }}>
            <FormControl component='fieldset' variant='standard'>
              <Grid container spacing={2}>
                {fieldList.map((col, index) => {
                  if (col.visible) {
                    if(col.field === 'id') {
                      return(
                        <Grid item xs={3} key={col.field}>
                        <TextField size='small'
                          disabled={true}
                          required fullWidth
                          name={col.field}
                          label={col.placeholder}
                          value={activeRow[col.field]}
                        />
                        <FormHelperTexts>{errors[col.field]}</FormHelperTexts>
                      </Grid>
                      )
                    }
                    return (
                      <Grid item xs={3} key={col.field}>
                        <TextField size='small'
                          required fullWidth
                          name={col.field}
                          label={col.placeholder}
                          defaultValue={activeRow[col.field]}
                          onChange={e => {
                            handleChange(e)
                          }} 
                        />
                        <FormHelperTexts>{errors[col.field]}</FormHelperTexts>
                      </Grid>
                    )
                  }
                })}
              </Grid>
            </FormControl>
          </Boxs>
          <Typography component='h1' variant='h5'>
            위탁업체
          </Typography>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={3} >
              <FormControl fullWidth>
                <InputLabel id='company' size='small'>
                  위탁업체
                </InputLabel>
                <Select
                  labelId='company'
                  required
                  label='위탁업체'
                  name={"companyId"}
                  value={activeRow["companyId"]}
                  size='small'
                  onChange={(e) => onChangeCompany(e)}>
                  {companies.map((s, index) => {
                    return (
                      <MenuItem key={index} value={s.id}>
                        {s.name}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>

            </Grid>
          </Grid>

          <Button disabled={false} variant='contained' color='primary' size='small' onClick={onSubmit} sx={{ mt: 10 }}>
            저장
          </Button>
        </Box>
      </Container>
    )
  }

  const dg_title = "학교 정보"
  const memo_DgContent = useMemo(() => {
    return <DgContent />
  }, [recordRef.current])

  if (dataList != null) {
    return (
      <div>
        <MyDialog title={dg_title} component={memo_DgContent} dialogHandler={dgHandler} />
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
          <Typography component='h1' variant='h5' align={"center"}>
            학교 관리
          </Typography>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Button
            variant='contained'
            color='primary'
            size='small'
            onClick={() => {
              onCreate()
            }}>
            생성
          </Button>
        </div>

        <div style={{ paddingTop: 20 }}>
          <MUITable>
            <MyTableHead>
              <TableRow>
                {fieldList.map((col, index) => {
                  if (col.visible) {
                    return (
                      <TableCell key={index} size='small' key={col.field}>
                        {col.placeholder}
                        {col.canSrch ? (
                          <Fragment>
                            <br />

                            <TextField
                              label=''
                              variant='outlined'
                              size='small'
                              inputProps={{ style: { fontSize: "0.875em", padding: 5, backgroundColor: "#fff" } }}
                              onChange={(e) => {
                                termsRef.current[col.field] = e.target.value
                              }}
                            />
                          </Fragment>
                        ) : (
                          <Fragment>
                            <br />
                            <br />
                          </Fragment>
                        )}
                      </TableCell>
                    )
                  }
                })}
                <TableCell size='small'>
                  <br />
                  <FlatButton ref={buttonRef} size='small' variant='contained' style={{ marginRight: 5 }} color='primary' onClick={onSearch}>
                    검색
                  </FlatButton>
                  {/*<FlatButton size='small' variant='contained'  color='primary' onClick={onClear}>지우기</FlatButton>*/}
                </TableCell>
              </TableRow>
            </MyTableHead>
            <TableBody>
              {dataList.map((row, index) => {
                return (
                  <Fragment key={index}>
                    <TableRow
                      onMouseEnter={() => {
                        recordRef.current = row
                        recordRef.current.companyId = -1
                      }}
                      onContextMenu={(e) => {
                        // e.preventDefault(); // 브라우저 기본 메뉴가 뜨는 것을 방지
                        dispatch(setSchola(row))
                        // alert('right clicked')
                      }}
                    >

                      {
                        fieldList.map((col, index2) => {
                          return (
                            col.visible ? (
                              col.field === 'name' ? (
                                <TableCell key={index2} size='small' onClick={() => {

                                  dispatch(setSchola(row))
                                }}>
                                  <Link to='/manager'>{row[col.field]}</Link>
                                </TableCell>
                              ) : (
                                <TableCell key={index2} size='small'>
                                  {row[col.field]}
                                </TableCell>
                              )
                            ) : null
                          )
                        })
                      }

                      <TableCell size='small'>
                        <FlatButton variant='outlined' size='small' style={{ marginRight: 5 }} onClick={() => onDetail(row.id)}>
                          보기
                        </FlatButton>
                        {/*<FlatButton variant='outlined'  color='error' size='small' onClick={() => onDelete(row.id)}>삭제</FlatButton>*/}
                      </TableCell>
                    </TableRow>
                  </Fragment>
                )
              })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 20, { label: "All", value: -1 }]}
                  colSpan={visibleColumns.length + 1}
                  count={totalCount}
                  rowsPerPage={pageInfo.pageSize}
                  page={pageInfo.pageNum}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  labelDisplayedRows={({ from, to, count }) => {
                    // return '' + from + '-' + to + ' 개 ' + count
                    return `${from} - ${to} of ${count}`
                  }}
                  labelRowsPerPage={"페이지당 갯수"}
                />
              </TableRow>
            </TableFooter>
          </MUITable>

          {renderIndicator()}
          {renderAlert()}
          <dg_content />
        </div>
      </div>
    )
  }
}

export default SchoolPage
